
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { mapState } from 'vuex';
import BackButton from '@/components/base/BackButton.vue';
import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs.vue';

export default Vue.extend({
	name: 'CompanySettingsOverview',
	props: {
		currTeam: { type: Object, default: null },
	},
	computed: {
		...mapState([
			'user',
			'team',
		]),
		breadcrumbs () {
			return [
				{
					hoverColor: 'var(--primary-purple)',
					text: 'Company Dashboard',
					disabled: false,
					to: {
						name: ROUTER.COMPANY_DASHBOARD,
					},
				},
				{
					hoverColor: 'var(--primary-blue)',
					text: 'Company Settings',
					disabled: true,
					to: {
						name: ROUTER.COMPANY_SETTINGS,
					},
				},
			];
		},
	},
	methods: {
		goBack () {
			// Go through breadcrumbs in reverse order to find the back route
			for (let i = this.breadcrumbs.length - 1; i >= 0; i--) {
				const breadcrumb = this.breadcrumbs[i];
				if (breadcrumb.to && !breadcrumb.disabled) {
					this.routerPush(this.$route, this.$router, breadcrumb.to);
					return;
				}
			}
		},
	},
	components: {
		BackButton,
		BaseBreadcrumbs,
	},
});
